module.exports = __webpack_public_path__ + "static/deliverImage@2x-129e3e10a0772d411efe6bc301b78c1d.png";